import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    ih1: {
      listFilters: [],
      branches: [],
      total: 0,
      selected: [],
      all: false,
      allBranches: [],
    },
    ih2: {
      listFilters: [],
      branches: [],
      total: 0,
      selected: [],
      all: false,
      allBranches: [],
    },
    loading: false,
    createdBranches: [],
    createdBranchesIh2: [],
    myIh1: '0',
    myHierarchies1: [],
    myIh2: '0',
    myHierarchies2: [],
  },

  mutations: {
    updateField,

    SET_BRANCHES_IH1(state, payload) {
      state.ih1.branches = payload.branches;
      state.ih1.total = payload.total || 1;
    },

    SET_BRANCHES_IH2(state, payload) {
      state.ih2.branches = payload.branches;
      state.ih2.total = payload.total || 1;
    },

    SET_LIST_BRANCHES_IH1(state, payload) {
      state.ih1.listFilters = payload.branches;
      state.ih1.allBranches = payload.allBranches;
      state.ih1.total = payload.total;
    },

    SET_LIST_BRANCHES_IH2(state, payload) {
      state.ih2.listFilters = payload.branches;
      state.ih2.total = payload.total || 1;
      state.ih2.allBranches = payload.allBranches;
    },

    SET_IH1(state, payload) {
      state.myIh1 = payload;
    },

    SET_MY_HIEHARCHIES1(state, payload) {
      state.myHierarchies1 = payload;
    },

    SET_MY_HIEHARCHIES2(state, payload) {
      state.myHierarchies2 = payload;
    },

    SET_IH2(state, payload) {
      state.myIh2 = payload;
    },
  },

  actions: {
    async setIh1({ commit }, id) {
      commit('SET_IH1', id);
    },

    async setMyHierarchies1({ commit }, arrayIds) {
      commit('SET_MY_HIEHARCHIES1', arrayIds);
    },

    async setMyHierarchies2({ commit }, arrayIds) {
      commit('SET_MY_HIEHARCHIES2', arrayIds);
    },

    async setIh2({ commit }, id) {
      commit('SET_IH2', id);
    },

    async listBranchesIh1({ commit }, obj) {
      try {
        const { data } = await axios.get(
          `${process.env.API_ROOT}/branches/${obj.companyId}`,
          {
            headers: {
              'x-access-token': obj.token,
            },
            params: {
              type: 'ih1',
              limit: obj.limit,
              page: obj.page,
            },
          },
        );

        commit('SET_LIST_BRANCHES_IH1', data);
      } catch (error) {
        window.console.log(error);
      }
    },

    async listBranchesIh2({ commit }, obj) {
      try {
        const { data } = await axios.get(
          `${process.env.API_ROOT}/branches/${obj.companyId}`,
          {
            headers: {
              'x-access-token': obj.token,
            },
            params: {
              type: 'ih2',
              limit: obj.limit,
              page: obj.page,
            },
          },
        );

        commit('SET_LIST_BRANCHES_IH2', data);
      } catch (error) {
        window.console.log(error);
      }
    },

    async getBranchesIH1({ commit }, obj) {
      try {
        const { data } = await axios.get(
          `${process.env.API_ROOT}/branches/${obj.companyId}`,
          {
            headers: {
              'x-access-token': obj.token,
            },
            params: {
              type: 'ih1',
              limit: obj.limit,
              page: obj.page,
              filter: obj.filter,
            },
          },
        );

        commit('SET_BRANCHES_IH1', data);
      } catch (error) {
        window.console.log(error);
      }
    },

    async getBranchesIH2({ commit }, obj) {
      try {
        const { data } = await axios.get(
          `${process.env.API_ROOT}/branches/${obj.companyId}`,
          {
            headers: {
              'x-access-token': obj.token,
            },
            params: {
              type: 'ih2',
              limit: obj.limit,
              page: obj.page,
              filter: obj.filter,
            },
          },
        );

        commit('SET_BRANCHES_IH2', data);
      } catch (error) {
        window.console.log(error);
      }
    },

    async addBranch({ commit }, obj) {
      await axios.post(
        `${process.env.API_ROOT}/branch/${obj.companyId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },

    async updatePermissions({ commit }, obj) {
      await axios.post(
        `${process.env.API_ROOT}/user/permissions/${obj.companyId}/${obj.userId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },

    async updateBranch({ commit }, obj) {
      await axios.put(
        `${process.env.API_ROOT}/branch/${obj.branchId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },

    async deleteBranch({ commit }, obj) {
      await axios.delete(`${process.env.API_ROOT}/branch/${obj.branchId}`, {
        headers: {
          'x-access-token': obj.token,
        },
      });
    },
  },

  getters: {
    getField,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/branches/index.js